import axiosHandler from "../../Intersepter/axiosInstance";

// Function to update an existing profile
export const updateProfile = async (payload) => {
  const response = await axiosHandler.put(`/profile/update`, payload);
  return response.data;
};
